// Copyright 2023, mochabug AB
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.5.2 with parameter "target=ts,json_types=true,ts_nocheck=true"
// @generated from file mochabugapis/adapt/graph/receiver.proto (package mochabugapis.adapt.graph, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../buf/validate/validate_pb";
import type { SignalBinding, SignalBindingJson } from "./signal_binding_pb";
import { file_mochabugapis_adapt_graph_signal_binding } from "./signal_binding_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mochabugapis/adapt/graph/receiver.proto.
 */
export const file_mochabugapis_adapt_graph_receiver: GenFile = /*@__PURE__*/
  fileDesc("Cidtb2NoYWJ1Z2FwaXMvYWRhcHQvZ3JhcGgvcmVjZWl2ZXIucHJvdG8SGG1vY2hhYnVnYXBpcy5hZGFwdC5ncmFwaCKqAgoIUmVjZWl2ZXISLQoEbmFtZRgBIAEoCUIfukgcchoQARgyMhReW18kYS16XVtfJGEtejAtOV0qJBIiCgtkZXNjcmlwdGlvbhgCIAEoCUIIukgFcgMY+gFIAIgBARK6AQoIYmluZGluZ3MYAyADKAsyJy5tb2NoYWJ1Z2FwaXMuYWRhcHQuZ3JhcGguU2lnbmFsQmluZGluZ0J/ukh8ugFzChViaW5kaW5nc191bmlxdWVfbmFtZXMSJUVhY2ggYmluZGluZyBtdXN0IGhhdmUgYSB1bmlxdWUgbmFtZS4aM3RoaXMubWFwKGJpbmRpbmcsIGJpbmRpbmcuZGVzY3JpcHRvci5uYW1lKS51bmlxdWUoKZIBAxCABEIOCgxfZGVzY3JpcHRpb25iBnByb3RvMw", [file_buf_validate_validate, file_mochabugapis_adapt_graph_signal_binding]);

/**
 * Receiver represents an input point for a vertex, which can bind
 * to multiple signals.
 *
 * @generated from message mochabugapis.adapt.graph.Receiver
 */
export type Receiver = Message<"mochabugapis.adapt.graph.Receiver"> & {
  /**
   * Identifier for the receiver, conforming to the ECMA naming pattern
   * and limited to 50 characters.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Optional descriptive text for the receiver's purpose, up to 250 characters.
   *
   * @generated from field: optional string description = 2;
   */
  description?: string;

  /**
   * List of signals the receiver listens for. Can contain up to 512 unique signals.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.SignalBinding bindings = 3;
   */
  bindings: SignalBinding[];
};

/**
 * Receiver represents an input point for a vertex, which can bind
 * to multiple signals.
 *
 * @generated from message mochabugapis.adapt.graph.Receiver
 */
export type ReceiverJson = {
  /**
   * Identifier for the receiver, conforming to the ECMA naming pattern
   * and limited to 50 characters.
   *
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * Optional descriptive text for the receiver's purpose, up to 250 characters.
   *
   * @generated from field: optional string description = 2;
   */
  description?: string;

  /**
   * List of signals the receiver listens for. Can contain up to 512 unique signals.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.SignalBinding bindings = 3;
   */
  bindings?: SignalBindingJson[];
};

/**
 * Describes the message mochabugapis.adapt.graph.Receiver.
 * Use `create(ReceiverSchema)` to create a new message.
 */
export const ReceiverSchema: GenMessage<Receiver, {jsonType: ReceiverJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_graph_receiver, 0);

